<template>
  <div class="event-table">
    <el-table :data="applicationArray" style="width: 100%" empty-text="No applications">
      <el-table-column prop="name" label="Users" :width="250">
        <template #default="scope">
          <router-link :to="{
            name: 'UserProfile',
            params: { link: scope.row.link },
          }">
            <div class="event-table__user">
              <el-avatar class="event-table__avatar" :size="50">
                <user-avatar :userId="scope.row.userId" :alt="scope.row.name" />
              </el-avatar>
              <span class="event-table__name">
                {{ scope.row.name }}
              </span>
            </div>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="comment" label="Comment">
        <template #default="scope">
          <div class="dash-if-empty">
            {{ scope.row.comments }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="vacancy" label="Vacancy">
        <template #default="scope">
          <div class="dash-if-empty">
            {{ scope.row.vacancyTitle }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="Status" :width="120">
        <template #default="scope">
          <div>
            {{ scope.row.status }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="" :width="300">
        <template #default="scope">
          <div class="event-table__buttons">
            <el-button type="primary" @click="requestApproveApplication(scope.row)" :disabled="isButtonDisabled(
              `change-application-status-${scope.row.applicationId}`,
            )
              ">
              Approve
            </el-button>
            <el-button type="primary" @click="requestRejectApplication(scope.row)" :disabled="isButtonDisabled(
              `change-application-status-${scope.row.applicationId}`,
            )
              ">
              Reject
            </el-button>

            <el-popover placement="bottom-end" width="64" trigger="hover">
              <div class="event-table__actions-menu">
                <div class="event-table__action" @click="requestLeaveApplicationOnHold(scope.row)" :disabled="isButtonDisabled(
                  `change-application-status-${scope.row.applicationId}`,
                )
                  ">
                  On hold
                </div>
                <div class="event-table__action" @click="requestSetApplicationToWaitList(scope.row)" :disabled="isButtonDisabled(
                  `change-application-status-${scope.row.applicationId}`,
                )
                  ">
                  To wait list
                </div>
                <div class="event-table__action" @click="handleOpenRequestInformationForm(scope.row)" :disabled="isButtonDisabled(
                  `change-application-status-${scope.row.applicationId}`,
                )
                  ">
                  Request information
                </div>
              </div>

              <template #reference>
                <span>
                  <el-button type="primary" class="event-table__actions">
                    <el-icon><More/></el-icon>
                  </el-button>
                </span>
              </template>
            </el-popover>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog v-model="isRequestInformationFormVisible" width="40%" title="Reply to the application">
      <div class="application-preview" v-if="applicationToResponse">
        <div class="application-preview__avatar">
          <router-link :to="{
            name: 'UserProfile',
            params: { link: applicationToResponse.link },
          }">
            <el-avatar :size="50">
              <user-avatar :userId="applicationToResponse.userId" :alt="applicationToResponse.name" />
            </el-avatar>
          </router-link>
        </div>

        <div class="application-preview__content">
          <div class="application-preview__name">
            {{ applicationToResponse.name }}
          </div>

          <div class="application-preview__comment">
            {{ applicationToResponse.comments }}
          </div>
        </div>
      </div>

      <el-form :rules="responseFormRules" :model="responseForm" ref="responseForm">
        <el-form-item prop="responseComment" :error="responseFormErrors.responseComments" label="Comment">
          <el-input v-model="responseForm.responseComments" type="textarea" :rows="4">
          </el-input>
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleCancelRequestAdditionalInformation">Cancel</el-button>
          <el-button type="primary" @click="validateApplicationResponseForm">Request</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  getIncomingEventApplications,
  approveEventApplication,
  rejectEventApplication,
  leaveEventApplicationOnHold,
  putEventApplicationToWaitList,
  returnEventApplication,
} from '@/api/events.js';

import { parseErrorsByFields } from '@/utils/index.js';
import { showMessage } from '@/utils/messages.js';
import { disableButton } from '@/mixins/disableButton.js';
import UserAvatar from '@/components/profile/UserAvatar.vue';

export default {
  name: 'EventApplications',
  props: {
    eventId: {
      type: Number,
      required: true,
    },
  },
  components: {
    UserAvatar,
  },
  mixins: [disableButton],
  data() {
    return {
      applicationArray: [],
      isRequestInformationFormVisible: false,
      responseForm: { responseComments: null },
      applicationToResponse: null,
      responseFormRules: {
        responseComment: [
          {
            required: true,
            trigger: 'input',
            message: 'Please enter your comment',
          },
        ],
      },
      responseFormErrors: { responseComments: null },
    };
  },
  methods: {
    parseErrorsByFields,
    showMessage,
    async fetchApplications() {
      const { eventId } = this;
      const { data, success } = await getIncomingEventApplications({ eventId });

      if (success) {

        console.log(data.items);
        this.setData(data.items);
      }
    },
    async requestApproveApplication({ applicationId, vacancyId }) {
      this.disableButton(`change-application-status-${applicationId}`);
      const { success } = 
        await approveEventApplication({ applicationId });

      this.enableButton(`change-application-status-${applicationId}`);

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'Application status has been updated',
        });
        this.$emit('update-data');
      }
    },
    async requestRejectApplication({ applicationId, vacancyId }) {
      this.disableButton(`change-application-status-${applicationId}`);
      const { success } = 
        await rejectEventApplication({ applicationId });
      this.enableButton(`change-application-status-${applicationId}`);

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'Application status has been updated',
        });
        this.$emit('update-data');
      }
    },
    async requestLeaveApplicationOnHold({ applicationId }) {
      this.disableButton(`change-application-status-${applicationId}`);
      const { success } = await leaveEventApplicationOnHold({ applicationId });
      this.enableButton(`change-application-status-${applicationId}`);

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'Application status has been updated',
        });
        this.$emit('update-data');
      }
    },
    async requestSetApplicationToWaitList({ applicationId }) {
      this.disableButton(`change-application-status-${applicationId}`);
      const { success } = await putEventApplicationToWaitList({
        applicationId,
      });
      this.enableButton(`change-application-status-${applicationId}`);

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'Application status has been updated',
        });
        this.$emit('update-data');
      }
    },
    async requestAdditionalInformation() {
      const { responseComments } = this.responseForm;
      const { applicationId } = this.applicationToResponse;
      this.disableButton(`change-application-status-${applicationId}`);

      const { data, success, errors } = await returnEventApplication({
        applicationId,
        responseComments: responseComments
          ? responseComments.trim()
          : responseComments,
      });
      this.enableButton(`change-application-status-${applicationId}`);

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'Your request has been sent',
        });
        this.$emit('update-data');

        this.responseForm.responseComments = null;
        this.responseFormErrors.responseComments = null;
        this.isRequestInformationFormVisible = false;
        this.applicationToResponse = null;
      } else if (errors) {
        this.responseFormErrors = {
          ...this.responseFormErrors,
          ...this.parseErrorsByFields(errors),
        };
      }
    },
    handleOpenRequestInformationForm(application) {
      this.isRequestInformationFormVisible = true;
      this.applicationToResponse = application;
      this.responseForm.responseComments = null;
    },
    validateApplicationResponseForm() {
      const { responseComments } = this.responseForm;
      const { applicationToResponse } = this;

      if (this.$refs.responseForm) {
        this.$refs.responseForm.validate();
      }

      if (
        responseComments &&
        responseComments.trim() &&
        applicationToResponse
      ) {
        this.requestAdditionalInformation();
      }
    },
    handleCancelRequestAdditionalInformation() {
      this.isRequestInformationFormVisible = false;
      this.applicationToResponse = null;
    },
    setData(data) {
      this.applicationArray = data.map((application) => {
        return {
          applicationId: application.applicationId,
          name: application.user.firstName + ' ' + application.user.lastName,
          userId: application.user.userId,
          link: application.user.link,
          status: application.status,
          comments: application.comments,
          vacancyTitle: application.vacancyTitle,
          vacancyId: application.vacancyId,
        };
      });

      console.log(this.applicationArray);
    },
  },
  created() {
    this.fetchApplications();
  },
};
</script>

<style lang="scss">
.event-table {
  &__buttons {
    text-align: right;
  }

  &__action {
    padding: var(--global-dimension-size-75) 0;
    cursor: pointer;
    font-weight: 500;

    &:hover {
      color: var(--color-primary-400);
    }
  }

  &__actions-menu {}

  &__actions {
    margin-left: var(--global-dimension-size-125);
  }
}

.application-preview {
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: var(--global-dimension-size-350);
  color: var(--color-gray-900);

  &__avatar {
    margin-right: var(--global-dimension-size-125);
  }

  &__content {
    line-height: 1.5;
  }

  &__name {
    font-size: var(--font-size-300);
  }

  &__comment {
    font-size: var(--font-size-200);
  }
}
</style>
